export const VERIFY_ROUTE_ACTION = "VERIFY_ROUTE_ACTION";
export const VERIFY_ROUTE_SUCCESS = "VERIFY_ROUTE_SUCCESS";
export const VERIFY_INIT = "VERIFY_INIT";
export const VERIFY_FAILED = "VERIFY_FAILED";
